'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'motorcycle';
var width = 640;
var height = 512;
var aliases = [127949];
var unicode = 'f21c';
var svgPathData = 'M448 32l-5.4 0-4.3 3.3L385 76.3 366.2 40.5 361.7 32 352 32l-80 0-16 0 0 32 16 0 70.3 0 16.9 32.1-127.4 98C199.9 172.6 161.4 160 120 160l-72 0-16 0 0 32 16 0 72 0c92.8 0 168 75.2 168 168l0 8 0 16 16 0 32 0 16 0 0-16 0-16c0-55.7 28.5-104.8 71.7-133.4l15 28.5C405.6 270.2 384 308.6 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-15.8 0-31 2.9-45 8.1L412.2 128l83.8 0 16 0 0-16 0-64 0-16-16 0-48 0zM408.7 190.1C355.4 224.2 320 284 320 352l-.2 0c-2.1-54-25.7-102.5-62.4-137.3l116.9-89.9 34.4 65.3zM416 352c0-31.1 14.8-58.8 37.8-76.3l44.1 83.8 7.5 14.2 28.3-14.9-7.4-14.2-44.1-83.8c9.4-3.1 19.5-4.8 29.9-4.8c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96zM480 96l-68.2 0 41.6-32L480 64l0 32zM128 256c47.6 0 87.1 34.6 94.7 80l-67 0c-5.5-9.6-15.9-16-27.7-16c-17.7 0-32 14.3-32 32s14.3 32 32 32c11.8 0 22.2-6.4 27.7-16l67 0c-7.6 45.4-47.1 80-94.7 80c-53 0-96-43-96-96s43-96 96-96zm128 96A128 128 0 1 0 0 352a128 128 0 1 0 256 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMotorcycle = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;